export enum PaddleEvent {
  CHECKOUT_CUSTOMER_DETAILS = 'Checkout.Customer.Details',
  CHECKOUT_CLOSE = 'Checkout.Close',
  CHECKOUT_COMPLETE = 'Checkout.Complete',
}
